import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays product price per m² and variant-specific information.
 * This component listens for variant update events and updates the display accordingly.
 */
class ProductPricePerM2 extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  /**
   * Updates the price and variant information when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the new product-price-per-m2 element in the updated HTML
    const newPricePerM2 = event.detail.data.html.querySelector(`product-price-per-m2[data-block-id="${this.dataset.blockId}"]`);
    if (!newPricePerM2) return;

    // Morph the entire component to update all content
    morph(this, newPricePerM2, { childrenOnly: true });
  };
}

if (!customElements.get('product-price-per-m2')) {
  customElements.define('product-price-per-m2', ProductPricePerM2);
}

